module.exports = __webpack_public_path__ + "static/media/time.d84f7ae3.jpg";